import { useState, useEffect } from "react";
import Steps from "../../steps";
import CustomMagicStepOne from "../custom-magic-step-one";
import CustomMagicStepTwo from "../custom-magic-step-two";
import CustomMagicStepThree from "../custom-magic-step-three";
import CustomMagicStepFour from "../custom-magic-step-four";
import { magicServices } from "../../../../services/InspectionOneServices";
import { useNavigate, useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { magicCreate } from "../../../../services/authFunctions";
import { useTranslation } from "react-i18next";
import Authentication from "../../../../auth/Authentication";
import ImageEditorWithPolygon from "../../../UI/new-canvas";
import ImageEditorWrapper from "../../../UI/image-editor-wrapper";
import { useMyContext } from "../../../my-context/MyContext";

function CreateCustomMagicSteps({ visionUpdated, setIsConfetti }: any) {
  const { id, magicType } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [mode, setMode] = useState("insert");
  const [currentStep, setCurrentStep] = useState<number>(1);
  const generateGuid = () => uuidv4();
  const authService = Authentication();
  const [isAutomation, setIsAutomation] = useState<boolean>(false);
  const { autoNavigate } = useMyContext();
  

  let parsedSideUserDetails: any;
  parsedSideUserDetails = authService.decryptData("UserDetails", 2);
  parsedSideUserDetails = parsedSideUserDetails || {};
  const manualSteps = [
    { label: t("web.magix.label.defineyourmagic") },
    { label: t("web.magix.label.defineyourmagicoutput") },
    { label: t("web.magix.label.uploadtrainingdataset") },
    { label: t("web.magix.label.reviewandsubmit") },
  ];

  const automationSteps = [
    { label: "Define your Automation Magic"},
    { label: "Automation Training"},
    { label: "Review and submit"}
  ];
  const stepsBluePrint = [
    { label: t("web.magix.label.defineyourmagic") },
    { label: t("web.magix.label.defineyourmagicpart") },
    { label: t("web.magix.label.reviewandsubmit") },
  ];
  const [selectedSteps, setSelectedSteps] = useState(() => {
  if (magicType === "5") return automationSteps;
  if (magicType === "4") return stepsBluePrint;
  return manualSteps;
});


  const [data, setData] = useState({
    isDeleted: 0,
    type: magicType,
    isCompleted: 0,
    pillar: 1,
    definition: 2,
    magicId: 0,
    inputType: 0,
    uniqueId: generateGuid(),
    inputSubType: 0,
    name: "",
    description: "",
    tags: [],
    overlay: "",
    thumbnail: "",
    surfaceType: "",
    modelTitle : "",
    modelTrainingType : "",
    isAutomation : false,
    defectsType: [],
    userType: parsedSideUserDetails.roleId,
    labels: [],
    outputs: [],
    cameraDetails: {
      isAutoCapture: false,
      flashlightMode: false,
      autoCaptureType: "",
    },
  });
  const [imageEditorUpdatedData, setImageEditorUpdatedData] = useState<any>();

  useEffect(() => {
    if (data.uniqueId) {
      setImageEditorUpdatedData(data);
    }
  }, [data]);

  const handleSubmit = async (isFinalStep: any) => {
    setIsLoading(true);
    setData(data);
    if (isFinalStep) {
      data.isCompleted = 1;
    }
    const response = await magicCreate(data);
    if (response.success) {
      if (isFinalStep) {
        setTimeout(() => {
          navigate(`/ai-magic-studio/vision/${magicType}`);
          visionUpdated(true);
          setIsLoading(false);
          setIsConfetti(true);
        }, 1000);
      } else {
        navigate(`/ai-magic-studio/vision/${magicType}`);
        visionUpdated(true);
        setIsLoading(false);
      }
    }
  };
  const handleMagicEdit = async (magicUnique: any) => {
    try {
      setIsLoading(true);
      const requestJson = {
        uniqueId: magicUnique,
        userType: parsedSideUserDetails.roleId,
      };
      const response = await magicServices.MagicDetails(requestJson);
      if (response.success) {
        setIsLoading(false);
        const newData = { ...response.data.magicDetails };
        setData(newData);
      } else {
        setIsLoading(false);
        setTimeout(() => {}, 1000);
      }
    if(autoNavigate.isNavigate){
      setCurrentStep(2);
    }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };
  //#region Alert
   
  const [isLoading, setIsLoading] = useState(false);

  //#endregion
  useEffect(() => {
    if (id !== "new") {
      setMode("update");
      handleMagicEdit(id);
    }
  }, [id]);

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <CustomMagicStepOne
            setCurrentStep={(step: any) => setCurrentStep(step)}
            title={manualSteps[0].label}
            data={data}
            setData={setData}
            handleSubmit={handleSubmit}
            isLoading={isLoading}
            isAutomation = {isAutomation}
            setIsAutomation = {setIsAutomation}
          />
        );
      case 2:
        return (
          // <StepsTest data={data} setData={setData} />
          <CustomMagicStepTwo
            setCurrentStep={(step: any) => setCurrentStep(step)}
            title={manualSteps[1].label}
            data={data}
            setData={setData}
            handleSubmit={handleSubmit}
            isLoading={isLoading}
            setImageEditorUpdatedData={setImageEditorUpdatedData}
            imageEditorUpdatedData={imageEditorUpdatedData}
          />
        );
      case 3:
        return (
          <CustomMagicStepThree
            setCurrentStep={(step: any) => setCurrentStep(step)}
            title={manualSteps[2].label}
            data={data}
            setData={setData}
            handleSubmit={handleSubmit}
            isLoading={isLoading}
          />
        );
      case 4:
        return (
          <CustomMagicStepFour
            setCurrentStep={(step: any) => setCurrentStep(step)}
            title={manualSteps[3].label}
            data={data}
            setData={setData}
            handleSubmit={handleSubmit}
            isLoading={isLoading}
          />
        );
      default:
        return null;
    }
  };
  const renderStepBluePrintContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <CustomMagicStepOne
            setCurrentStep={(step: any) => setCurrentStep(step)}
            title={stepsBluePrint[0].label}
            data={data}
            setData={setData}
            handleSubmit={handleSubmit}
            isLoading={isLoading}
            isAutomation = {isAutomation}
            setIsAutomation = {setIsAutomation}
          />
        );
      case 2:
        return (
          <CustomMagicStepTwo
            setCurrentStep={(step: any) => setCurrentStep(step)}
            title={stepsBluePrint[1].label}
            data={data}
            setData={setData}
            handleSubmit={handleSubmit}
            isLoading={isLoading}
            setImageEditorUpdatedData={setImageEditorUpdatedData}
            imageEditorUpdatedData={imageEditorUpdatedData}
          />
        );
      case 3:
        return (
          <CustomMagicStepFour
            setCurrentStep={(step: any) => setCurrentStep(step)}
            title={stepsBluePrint[2].label}
            data={data}
            setData={setData}
            handleSubmit={handleSubmit}
            isLoading={isLoading}
          />
        );
      default:
        return null;
    }
  };
const automationStepContent = () =>{
    switch (currentStep) {
      case 1:
        return (
          <CustomMagicStepOne
            setCurrentStep={(step: any) => setCurrentStep(step)}
            title={automationSteps[0].label}
            data={data}
            setData={setData}
            handleSubmit={handleSubmit}
            isLoading={isLoading}
            isAutomation = {isAutomation}
            setIsAutomation = {setIsAutomation}
          />
        ); 
        case 2 :
          return(
            <ImageEditorWrapper 
              data={data}
              setData={setData}
              setCurrentStep={(step: any) => setCurrentStep(step)}
              handleSubmit={handleSubmit}
              />
          );
        case 3:
        return (
          <CustomMagicStepFour
            setCurrentStep={(step: any) => setCurrentStep(step)}
            title={manualSteps[3].label}
            data={data}
            setData={setData}
            handleSubmit={handleSubmit}
            isLoading={isLoading}
          />
        );  
        default: 
        return null;
  }
 
};
useEffect(() => {
  switch (magicType) {
    case "2":
      setSelectedSteps(automationSteps);
      break;
    case "4":
      setSelectedSteps(stepsBluePrint);
      break;
    default:
      setSelectedSteps(manualSteps);
  }
}, [magicType]);

const renderSelectedStep = () => {
  if (magicType === "2") {
    return automationStepContent();
  } else if (magicType === "4") {
    return renderStepBluePrintContent();
  }
  return renderStepContent();
};

  return (
    <div className="w-full h-full flex flex-col">
      <Steps
        currentStep={currentStep}
        steps={selectedSteps}
      />
      <div className="w-full max-h-full flex-auto">
         {renderSelectedStep()}
      </div>
    </div>
  );
}
export default CreateCustomMagicSteps;
